import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight, Trophy } from 'lucide-react';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tier = searchParams.get('tier') || '';
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center p-4" data-testid="success-page">
      <div className="max-w-lg w-full text-center space-y-8">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#00BFA6]/20 mx-auto">
          <CheckCircle className="w-14 h-14 text-[#00BFA6]" />
        </div>

        <h1 className="text-4xl font-bold">Zahlung erfolgreich!</h1>

        <p className="text-gray-400 text-lg">
          Dein <span className="text-[#00BFA6] font-bold">{tier.toUpperCase() || 'Abo'}</span>-Plan
          wurde aktiviert.
        </p>

        <div className="bg-[#1E1E1E] border border-white/10 rounded-xl p-6 space-y-3">
          <div className="flex items-center gap-3 text-left">
            <Trophy className="w-5 h-5 text-[#00BFA6] shrink-0" />
            <span>Deine Tipps sind jetzt freigeschaltet</span>
          </div>
          <div className="flex items-center gap-3 text-left">
            <Trophy className="w-5 h-5 text-[#00BFA6] shrink-0" />
            <span>Multi-AI Analysen aktiviert</span>
          </div>
          <div className="flex items-center gap-3 text-left">
            <Trophy className="w-5 h-5 text-[#00BFA6] shrink-0" />
            <span>Push-Benachrichtigungen verfügbar</span>
          </div>
        </div>

        <Button
          onClick={() => navigate('/dashboard')}
          className="bg-[#00BFA6] hover:bg-[#009E8A] text-black font-bold py-6 px-8 text-lg"
          data-testid="go-to-dashboard-btn"
        >
          Zum Dashboard <ArrowRight className="ml-2 w-5 h-5" />
        </Button>

        <p className="text-sm text-gray-500">
          Automatische Weiterleitung in {countdown}s...
        </p>
      </div>
    </div>
  );
};

export default SuccessPage;
